import '../vendors/jquery.easydropdown';

class Dropdowns {

    constructor() {
        this.init();
    }

    init() {

		$('.custom-select').easyDropDown({
			cutOff: 6,
			onChange: function(selected){

				// remove error css class from label related to select
				if(selected.value != ''){
					let elementLabel = document.querySelector( 'label[for="'+ this.id +'"]' );

					if( elementLabel ){
						elementLabel.classList.remove('error');
						return;
					}

				}
			}
		});

    }
}

export default Dropdowns;



// WEBPACK FOOTER //
// ./scripts/modules/dropdowns.js